/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { task } from 'ember-concurrency';
import ApiService from 'cio/services/api';
import AnalyticsService from 'cio/services/analytics';
import ImportModel from 'cio/models/import';
import exportUrl, { ExportType, EVENT_NAMES } from 'cio/utils/imports/export-url';

interface ExportButtonArgs {
  type: ExportType;
  import: ImportModel;
  buttonText: string;
  isDisabled?: boolean;
}

export const OPTION_ORIGINAL = { value: ExportType.Original, label: 'Original File' };
export const OPTION_WARNINGS = { value: ExportType.Warnings, label: 'Warning Report' };
export const OPTION_ERRORS = { value: ExportType.Errors, label: 'Error Report' };
export const OPTION_IMPORT = { value: ExportType.Import, label: 'Actual Import' };

export default class ExportButton extends Component<ExportButtonArgs> {
  @service api!: ApiService;
  @service analytics!: AnalyticsService;

  downloadExport = task({ enqueue: true }, async () => {
    if (!this.exportUrl) {
      return;
    }

    try {
      let response = await this.api.post(this.exportUrl);
      window.location = response.url;
      this.analytics.track('import', EVENT_NAMES[this.args.type], { model: this.args.import });
    } catch {
      // ignore errors
    }
  });

  get exportUrl() {
    return exportUrl(this.args.type, this.args.import);
  }
}
